app.controller("playCtrl", [
  "$scope",
  "$location",
  "$http",
  "config",
  "$routeParams",
  "$localStorage",
  "checkUser",
  "$sce",
  "decrypt",
  "ContentFactory",
  "getSiteDetails",
  function (
    $scope,
    $location,
    $http,
    config,
    $routeParams,
    $localStorage,
    checkUser,
    $sce,
    decrypt,
    ContentFactory,
    getSiteDetails
  ) {
    checkUser.verifyLogin(
      () => {},
      () => {
        $localStorage.redirect = window.location.href;
        $location.path("/login");
      }
    );

    $(window).scrollTop(0);

    $scope.contentID = $routeParams.contentID;
    var playlistId = $routeParams.playlistID;
    $scope.access = false;
    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    checkTicket($scope.contentID);

    function checkTicket(contentID) {
      if ($localStorage.shopUserID !== undefined) {
        ContentFactory.getCustomerTickets($localStorage.shopUserID).then(
          function (tickets) {
            for (let i = 0; i < tickets.length; i++) {
              if (tickets[i].contentID === contentID) {
                $scope.access = true;
              }
              if (playlistId) {
                if (tickets[i].contentID === playlistId) {
                  $scope.access = true;
                }
              }
            }

            $scope.companionUrl = null;
            $scope.descriptionIframe = null;

            ContentFactory.getContentType(contentID).then(
              function success(res) {
                const contentType = res;
                $http({
                  method: "GET",
                  url:
                    config.publicApiUrl +
                    `getShopContentByID/${$localStorage.siteID}/${contentType}/${contentID}`,
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                }).then(
                  function success(response) {
                    const contentData = response.data.data[0];

                    if (!contentData) {
                      $scope.access = false;
                      $("#noAccess").show();
                      return;
                    }

                    if (contentData.cost === "0.00") {
                      if (siteConfig.logFree == "1") {
                        var postdata = {
                          email: $localStorage.email,
                          contentID: $scope.contentID,
                        };
                        $http({
                          method: "POST",
                          url: config.fstreamAPI + "logEmail",
                          headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                          },
                          data: postdata,
                        }).then(
                          function success() {},
                          function error() {}
                        );
                      }
                    }

                    $scope.contentInfo = contentData;
                    let playerType;
                    if (Array.isArray(contentData.metadata)) {
                      for (let metadata of contentData.metadata) {
                        if (metadata.key === "companionURL") {
                          $scope.companionUrl = $sce.trustAsResourceUrl(
                            metadata.text
                          );
                        }
                        if (metadata.key === "descriptionIframe") {
                          $scope.descriptionIframe = $sce.trustAsResourceUrl(
                            metadata.text
                          );
                        }
                      }
                    }

                    $http({
                      method: "GET",
                      url: `${config.fstreamAPI}getCustomerPlayer/${contentID}`,
                      headers: {
                        "Content-Type": "application/json", //x-www-form-urlencoded
                        Accept: "application/json",
                      },
                    }).then(
                      function success(res) {
                        const playerUrl = res.data.url + "&dp=1&bm=1";
                        $scope.access = true;
                        $scope.iframeURL = $sce.trustAsResourceUrl(
                          playerType ? `${playerUrl}${playerType}` : playerUrl
                        );
                      },
                      function error(res) {
                        $scope.access = true;
                        $("#noAccess").show();
                      }
                    );
                  },
                  function error(response) {
                    console.log(response);
                  }
                );
              },
              function error() {
                $scope.access = false;
                $("#noAccess").show();
              }
            );
          }
        );
      }
    }

    let darkmode = false;
    $scope.darkmode = function () {
      if (darkmode) {
        $("#darkmodeBtn").addClass("btn-primary");
        $("#darkmodeBtn").removeClass("btn-dark");
        $("#darkmodeBtn").text("Dark Mode");
        $("#overlay").hide();
        darkmode = false;
      } else {
        $("#darkmodeBtn").addClass("btn-dark");
        $("#darkmodeBtn").removeClass("btn-primary");
        $("#darkmodeBtn").text("Light Mode");
        $("#overlay").show();
        darkmode = true;
      }
    };

    getSiteDetails
      .getPlayPageElements(siteConfig.micrositeID)
      .then((result) => {
        $scope.playPageElements = result.content;
      })
      .catch((err) => {
        $scope.playPageElements = [];
      });
  },
]);

app.controller("playlistCtrl", [
  "$scope",
  "$http",
  "$location",
  "$routeParams",
  "config",
  "decrypt",
  "$route",
  "$sce",
  "$q",
  "$localStorage",
  "checkUser",
  "DTOptionsBuilder",
  "DTColumnBuilder",
  "$window",
  "$interval",
  "$rootScope",
  "$compile",
  "FiveStreamApiFactory",
  function (
    $scope,
    $http,
    $location,
    $routeParams,
    config,
    decrypt,
    $route,
    $sce,
    $q,
    $localStorage,
    checkUser,
    DTOptionsBuilder,
    DTColumnBuilder,
    $window,
    $interval,
    $rootScope,
    $compile,
    FiveStreamApiFactory
  ) {
    let microsite = JSON.parse($localStorage.microsite);
    let siteConfig = microsite.microsite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    checkUser.verifyLogin(
      () => {},
      () => {
        $localStorage.redirect = "#/home";
        $location.path("/login");
      }
    );

    var playlistID = $routeParams.playlistID;

    FiveStreamApiFactory.verifyCustomerOwnsContent(playlistID).catch(() => {
      $location.path("/");
    });

    $scope.dtOptions = DTOptionsBuilder.newOptions()
      .withOption("ajax", {
        url: config.fstreamAPI + "contentSubscription",
        type: "GET",
        xhrFields: {
          withCredentials: true,
        },
        data: function (d) {
          d.playlistID = playlistID;
        },
        error: function(xhr, error, status) {console.log(error)},
      })
      .withDataProp("data")
      .withOption("processing", true)
      .withOption("serverSide", true)
      .withOption("responsive", false)
      .withOption("createdRow", function (row, data, dataIndex) {
        $compile(angular.element(row).contents())($scope);
      })
      .withOption("initComplete", function (settings, json) {
        $("#dtMaterialDesignExample_wrapper")
          .find("label")
          .each(function () {});
        $("#dtMaterialDesignExample_wrapper .dataTables_filter")
          .find("input")
          .each(function () {
            const $this = $(this);
          });
        $("#dtMaterialDesignExample_wrapper").removeClass("form-inline");
      })
      .withPaginationType("full_numbers");
    $scope.dtColumns = [
      DTColumnBuilder.newColumn("contentID")
        .withTitle("ID")
        .notSortable()
        .withClass("hiddencol d-none d-sm-table-cell"),
      DTColumnBuilder.newColumn(null)
        .withTitle("")
        .withOption("searchable", false)
        .renderWith(posterImage)
        .withClass("d-none d-sm-table-cell")
        .notSortable(),
      DTColumnBuilder.newColumn(null)
        .withTitle("")
        .renderWith(checkStart)
        .withOption("searchable", false)
        .notSortable(),
      DTColumnBuilder.newColumn(null)
        .withTitle("")
        .withOption("searchable", false)
        .renderWith(playIt)
        .notSortable(),
    ];

    function checkStart(data, type, full, meta) {
      if (data.start > 0) {
        var nowDate = new Date();
        var now = nowDate.getTime() / 1000;

        // If live content as VOD childID set
        if (data.childID) {
          return (
            "<strong>" +
            data.title +
            "</strong><br><small class='text-info'>Available now</small>"
          );
        }

        if (data.start < now && data.end > now) {
          return (
            "<strong>" +
            data.title +
            "</strong><br><small class='text-info'>Live now</small>"
          );
        }

        if (data.start < now && data.end < now) {
          return (
            "<strong>" +
            data.title +
            "</strong><br><small class='text-info'>Stream Complete</small>"
          );
        }

        if (data.start > now) {
          //countdownInterval = $interval(calculateCountdown, 1000)
          //function calculateCountdown() {

          return (
            "<strong>" +
            data.title +
            "</strong><br><small class='text-info'>" +
            moment.unix(data.start).format("LLLL") +
            "</small>"
          );

          //}
        }
      } else {
        return (
          "<strong>" +
          data.title +
          "</strong><br><small class='text-info'>Available now</small>"
        );
      }
    }

    function playIt(data, type, full, meta) {
      if (data.contentTypeID === "15") {
        return `<a href="#/playlist/${data.contentID}" class="btn btn-primary btn-sm" type="button"><i class="fa fa-list"></i></a>`;
      }

      // If live content as VOD childID set
      if (data.childID) {
        return `<a href="#/play/${data.contentID}/playlistID" class="btn btn-success btn-sm" type="button"><i class="fa fa-play"></i></a>`;
      }

      var nowDate = new Date();
      var now = nowDate.getTime() / 1000;
      if (data.start > 0) {
        if (data.start < now && data.end < now) {
          return '<a href="" class="btn btn-light btn-sm" type="button" disabled><i class="fa fa-play"></i></a>';
        } else {
          return (
            '<a href="#/play/' +
            data.contentID +
            "/" +
            playlistID +
            '" class="btn btn-success btn-sm" type="button"><i class="fa fa-play"></i></a>'
          );
        }
      } else {
        return (
          '<a href="#/play/' +
          data.contentID +
          "/" +
          playlistID +
          '" class="btn btn-success btn-sm" type="button"><i class="fa fa-play"></i></a>'
        );
      }
    }

    function posterImage(data, type, full, meta) {
      return '<img src="https://' + data.poster + '" width="100" loading="lazy">';
    }
  },
]);
